import { BaseRequest } from './BaseRequest';

export class ContactRequest extends BaseRequest {
    ContactIdentity : string | null;
    
    constructor(contactIdentity: string, clusterName: string, botIdentifier: string) {
      super();
      this.ContactIdentity = contactIdentity;
      this.ClusterName = clusterName;
      this.BotIdentifier = botIdentifier;
    }
}